import type * as core from '../../../../../../../core'

export const query: core.mosaic.Page.Query = {
  filter: {
    '=': [
      {
        '@.': '!id',
      },
      {
        '@$': 'subrecipientId',
      },
    ],
  },
  target: 'ent:!subrecips:!subrecip',
  quantity: 1,
  selection: {
    '{}': {
      title: {
        '@.': '!name',
      },
      breadcrumbs: {
        '[]': [
          {
            '{}': {
              goto: {
                '{}': {
                  navigationId: 'subrecipients',
                },
              },
              name: 'Subrecipients',
            },
          },
        ],
      },
    },
  },
}
